import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import numeral from 'numeral'

function LandingPageCategoryBox({
  category, competitionSlug, activeSectionSlug, imgPath,
}) {
  const imgUrl = imgPath

  return (
    <div className="col-12 col-md-4 landing-page__category-box">
      <Link to={`/${competitionSlug}/categories-and-prizes`} state={{ activeSectionSlug }}>
        <div className="category-box__content" style={{ backgroundImage: `url(${imgUrl})` }}>
          <div className="content__text-background" />
        </div>
      </Link>
      <div className="category-box__info">
        <div className="category-title">
          {category.short_title} <Link to={`/${competitionSlug}/categories-and-prizes`} state={{ activeSectionSlug }} className="btn btn-sm btn-outline-primary">{category.prizes.prize_pool} prize pool</Link>
        </div>
        <small>
          Presented by: <span className="text-semibold">{category.sponsor.name}</span>
        </small>
      </div>
    </div>
  )
}

LandingPageCategoryBox.propTypes = {
  category: PropTypes.shape({
    short_title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    sponsor: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    prizes: PropTypes.shape({
      prize_pool: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  competitionSlug: PropTypes.string.isRequired,
  activeSectionSlug: PropTypes.string.isRequired,
  imgPath: PropTypes.string.isRequired,
}

export default LandingPageCategoryBox
